// extracted by mini-css-extract-plugin
export default {"NavBar":"NavBar_NavBar__uAJAH","Logo":"NavBar_Logo__97Hy+"};